import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { TuiLoader } from '@taiga-ui/core';
import { TuiProgress } from '@taiga-ui/kit';

/**
 * Shared generating state for an insight. `percent` is 0–100.
 * An empty `text` shows `fallback`.
 */
@Component({
	standalone: true,
	selector: 'mar-insight-progress',
	imports: [TuiLoader, TuiProgress],
	templateUrl: 'insight-progress.component.html',
	styleUrl: 'insight-progress.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'grid w-64 shrink-0 grid-cols-[auto_minmax(0,1fr)] grid-rows-2 items-center gap-x-2 gap-y-0',
		'[attr.data-progress]': 'true',
	},
})
export class InsightProgressComponent {
	readonly percent = input(0);
	readonly text = input('');
	readonly fallback = input.required<string>();

	readonly label = computed(() => this.text().trim() || this.fallback());

	readonly shownPercent = computed(() => {
		const value = this.percent();
		if (!Number.isFinite(value)) return 0;
		return Math.min(100, Math.max(0, Math.round(value)));
	});
}
